export const ROUTE_LOGIN = '/auth/login'
export const ROUTE_REGISTER = '/auth/register'
export const ROUTE_LOGIN_SUCCESS = '/auth/login/success'
export const ROUTE_REGISTER_SUCCESS = '/auth/register/success'
export const ROUTE_LOGIN_ERROR = '/auth/login/error'
export const ROUTE_REGISTER_ERROR = '/auth/register/error'

export const validateMessages = [
  'required',
  'passwordMax',
  'validPhoneNumber',
]